import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, CalendarCheck } from "lucide-react";
import { site } from "../mock/mock";
import { openEnquiry } from "./EnquiryModal";
import { logContactEvent } from "../lib/api";

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden" style={{ background: "var(--teal-900)" }}>
      <img
        src="/campus/school-4.jpg"
        alt="The KPR Academy campus"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ opacity: 0.28 }}
        loading="lazy"
      />
      <div className="grain absolute inset-0" />

      <div className="relative mx-auto max-w-[1280px] px-5 py-20 lg:px-6 lg:py-24">
        <div className="flex flex-col items-start gap-10 lg:flex-row lg:items-center lg:justify-between">
          <div data-reveal="">
            <div className="flex items-center gap-3">
              <span className="h-[6px] w-[6px] rotate-45" style={{ background: "var(--gold-400)" }} />
              <span className="eyebrow" style={{ color: "var(--gold-200)" }}>
                Admissions open · 2026–27
              </span>
            </div>
            <h2
              className="font-display mt-5 max-w-[640px] text-[2.1rem] leading-[1.1] sm:text-[2.8rem]"
              style={{ color: "#FBF7F0", fontWeight: 300 }}
            >
              Book a campus visit for your child this week
            </h2>
            <p className="mt-5 max-w-[560px] text-[1rem] leading-relaxed" style={{ color: "rgba(251,247,240,.75)" }}>
              Walk the labs, library, arenas and dining hall with our team. Tell us when you are free and we will
              arrange the rest.
            </p>
          </div>

          <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row lg:flex-col" data-reveal="">
            <button
              onClick={openEnquiry}
              className="group flex items-center justify-center gap-3 rounded-full px-8 py-4 text-[0.88rem] font-semibold"
              style={{
                background: "var(--gold)",
                color: "#fff",
                transition: "transform .3s ease, box-shadow .3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 18px 34px -16px rgba(192,138,46,.9)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <CalendarCheck size={17} /> Admission Enquiry
              <ArrowRight size={16} className="group-hover:translate-x-1" style={{ transition: "transform .3s ease" }} />
            </button>

            <a
              href={`tel:${site.hotlines[0].replace(/\s/g, "")}`}
              onClick={() =>
                logContactEvent({
                  channel: "call",
                  number: site.hotlines[0].replace(/\s/g, ""),
                  display: site.hotlines[0],
                  label: "cta band",
                })
              }
              className="flex items-center justify-center gap-3 rounded-full px-8 py-4 text-[0.88rem] font-semibold"
              style={{ border: "1px solid rgba(251,247,240,.4)", color: "#FBF7F0" }}
            >
              <Phone size={16} /> {site.hotlines[0]}
            </a>

            <Link
              to="/downloads"
              className="text-center text-[0.8rem] font-semibold underline-grow"
              style={{ color: "var(--gold-200)" }}
            >
              Or download the enquiry form
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
